import { CacheConfig, HttpRequestConfig, HttpResponse } from '@/utils/http-utils';
import { ApiCallResponseStatus } from '@/entities/api.call.sresponse.tatus';
import { PLBoxInstanceAttribute } from '@/entities/contactus/submit-contact-us-ent';
import siteConfigService from './site.config.service';
import httpService from './http.service';

class PLBoxInstanceAttributeService {
  private genericAttributeEndPointUrl: string = 'generic.plboxInstanceAttribute.retrieve';

  public async getAttribute(plId: number, attributeTypeId: number, attributeKey: string, allowDefault: string = 'true', templateId: number = 0): Promise<PLBoxInstanceAttribute> {
    let apiEndpoint: any = await siteConfigService.getApiEndpoint(this.genericAttributeEndPointUrl);
    apiEndpoint = apiEndpoint.replace('{plId}', plId);
    apiEndpoint = apiEndpoint.replace('{attributeKey}', attributeKey);
    apiEndpoint = apiEndpoint.replace('{attributeTypeId}', attributeTypeId);
    const cacheName: string = 'PageAttributeByPlIdAndAttributeKey';
    const cacheKey: string = `${plId}.${attributeTypeId}.${attributeKey}`;
    const cacheConfig: CacheConfig = {
      name: cacheName,
      key: cacheKey,
      options: {
        cacheKeepOneKeyOnly: true,
        timeToLive: -1,
        forceUpdate: false,
      },
    };
    const config: HttpRequestConfig = {
      cache: cacheConfig,
    };


    if (!!process.env.NODE_ENV && (process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'e2etest')) {
      // use mock
    } else {
      apiEndpoint += `&allowDefaultValue=${allowDefault}&templateId=${templateId}`;
    }

    try {
      const res: HttpResponse<PLBoxInstanceAttribute> = await httpService.get<PLBoxInstanceAttribute>(apiEndpoint, config);
      const status: PLBoxInstanceAttribute = res.data;
      return status;
    } catch (e) {
      const apiCallResponseStatus: ApiCallResponseStatus = e.response.data;
      apiCallResponseStatus.original = e;
      throw apiCallResponseStatus;
    }
  }
}
// Export a singleton instance in the global namespace
export default new PLBoxInstanceAttributeService();
